export function floorTo(value: number, digits: number) {
  let multiplier = '1';
  for (let i = 1; i <= digits; i++) {
    multiplier += '0';
  }

  const floored =
    Math.floor((value + Number.EPSILON) * parseInt(multiplier)) /
    parseInt(multiplier);

  return floored;
}
